export enum RoleKey {
  SOFTWARE_ENGINEER = "SOFTWARE_ENGINEER",
  TECH_LEAD = "TECH_LEAD",
  QA_ENGINEER = "QA_ENGINEER",
  PROJECT_MANAGER = "PROJECT_MANAGER",
  CUSTOMER_SUPPORT = "CUSTOMER_SUPPORT",
}
